import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Platform } from '@ionic/angular';
import { LocationService } from '../location.service';
import { AuthService } from '../auth.service';
import { auth } from 'firebase';

@Component({
  selector: 'app-customer-profile',
  templateUrl: './customer-profile.component.html',
  styleUrls: ['./customer-profile.component.scss'],
})
export class CustomerProfileComponent  {
  loader:boolean = false;
  editBool:boolean=false;
  passwordPolicy:boolean=false;
  numCd = "+91"
  mob;
  url;
  id;
  firstName;
  fName;
  lName;
  numb;
  hide;
  pic:any;
  org;
  street;
  wallet:boolean;
  details;
  categoryId;
  buttonObj:any=[{name:"Individual House",flat:false,id:1},
{name:"Flat",flat:true,id:2}]
flatType = this.buttonObj[0].id;
appt:boolean = this.buttonObj[0].flat;
flatNo;
flatName;
pass;
doorNbr;
view:boolean=false;
creditpoint;
  constructor(private router: Router,public location: LocationService, public handler: HandlerService, private platform: Platform,
   public service: ApiService, public auth: AuthService) { }
  
  
    ionViewWillEnter(){
      let url=window.location.href
      this.url = this.router.url;
      this.numb = sessionStorage.getItem('mobile#')
      this.fName = sessionStorage.getItem('firstName')
      this.categoryId = sessionStorage.getItem('id')
      this.id = this.url.split('/').pop();
      if(url.includes('edit')) {
        this.editBool=true;
        this.getUser();
        }
     if(url.includes('customerProfile1')||url.includes('customerProfile2') || url.includes('purchaserProfile')){
       this.view=true;
     }
   }
 
 
    getUser(){
     this.loader = true;
     this.service.getUserById(this.id).subscribe((res:any)=>{
       this.details=res;
       this.loader = false;
       this.fName = this.details.firstName;
       this.lName = this.details.lastName;
       this.numb = this.details.contactNbrMob.slice(3); 
       if(res.addresses[0]){
        this.location.street = res.addresses[0].street;
        this.location.regionId = res.addresses[0].regionId;
        this.location.cityId = res.addresses[0].cityId;
        this.location.stateId = res.addresses[0].stateId;
        this.location.zipcode =res.addresses[0].zipcode;
        this.appt=res.addresses[0].appt;
        if(!this.appt){
          this.flatType = 1;
        }else{
          this.flatType = 2;
        }
        this.doorNbr=res.addresses[0].houseNbr;
        this.flatNo=res.addresses[0].flatNo;
        this.flatName=res.addresses[0].flatName;  
        this.location.lat=res.addresses[0].lat; 
        this.location.lon=res.addresses[0].lon; 
       }
  
     })
   }
   register() {
    if(this.fName && this.numb!=""){
    if (!this.loader && this.fName &&  this.numb && this.org && this.lName )
    if(this.fName){
      this.fName = this.fName.toUpperCase();
    }
    if(this.lName){
      this.lName = this.lName.toUpperCase();
    }
     if(this.org){
      this.org = this.org.toUpperCase();
    }
      var x= {  
          "cityId": this.location.cityId,
          "stateId": this.location.stateId,
          "regionId":this.location.regionId,
          "zipcode":this.location.zipcode,
          "lat": this.location.lat,
          "lon": this.location.lon,
          "type": 1,
          "appt":this.appt,
      }
    
      var post = {
        contactNbrMob: '+91'+ this.numb,
        firstName: this.fName,
        lastName: this.lName,
         userType: 1,
        orgCode:'YB',
        genderCd:1,
        appId: 14,
        pic:this.pic,
        roles: ['CUST'],
        "addresses":[x]
      }
      if(!this.appt){
        Object.assign(x,{"doorNbr":this.location.houseNbr,"street": this.location.street})
      }else{
        Object.assign(x,{"flatNo":this.flatNo, "flatName":this.flatName,})
      }
      if(this.url.includes('customerProfile1')|| this.url.includes('customerProfile2')|| this.url.includes('purchaserProfile')){
        Object.assign(post,{password: window.btoa(this.pass)})
      }else{
        Object.assign(post,{paless: true})
      }   
    this.loader = true;
    this.service.register(post).subscribe(
      (res: any) => {
        localStorage.setItem('organizationId', '790');
         localStorage.setItem('vendorcustId', res.userId);
        window['mock'] = res;      
        this.handler.res('Registered Successfully !!')
        let url = window.location.href;  
        if(this.url.includes('newCustomer')){
          this.router.navigate(["customerItem"]);
        } 
        if(this.url.includes('newCustomerService')){
          this.router.navigate(["single-request",+res.userId]);
        }
        if(this.url.includes('customerProfile')){
          this.router.navigate(["customer"]);
        }  
        if(this.url.includes('customerProfile1')){
         // this.router.navigate(['customer-reg']);
          this.router.navigate(['validateForOrder']);
        } 
        if(this.url.includes('customerProfile2')){
          this.router.navigate(['validateForSubs']);
          // this.router.navigate(["subs-cust-register"]);
        }   
        if(this.url.includes('customerProfile2')){
          sessionStorage.setItem('singleReq','false')
          this.router.navigate(['validateForPurc']);
          // this.router.navigate(["subs-cust-register"]);
        }    
        this.loader = false;
      },
      err => {
        this.handler.err(err);
        this.loader = false;
      })
     }
    else{
      this.handler.res("Please Enter The phone number and name");
    }
  }
   updateUser(){
    this.loader = true;
  this.details.firstName = this.fName;
  this.details.lastName = this.lName;
  this.details.contactNbrMob =  this.numCd + this.numb  ;
  var x;
  if(!this.appt){
    x= {  
      "cityId": this.location.cityId,
      "stateId": this.location.stateId,
      "regionId":this.location.regionId,
      "zipcode":this.location.zipcode,
      "lat": this.location.lat,
      "lon": this.location.lon,
      "type": 1,
      "appt":false,
      "street":this.location.street,
      "doorNbr":this.location.houseNbr
  }
  }else{
    x= {  
      "cityId": this.location.cityId,
      "stateId": this.location.stateId,
      "regionId":this.location.regionId,
      "zipcode":this.location.zipcode,
      "lat": this.location.lat,
      "lon": this.location.lon,
      "type": 1,
      "appt":true,
      "flatName":this.flatName,
      "flatNo":this.flatNo
  }
  }
  if(!this.details.addresses){
    this.details.addresses.push(x)
  }else{
    this.details.addresses[0]=x
  }
  this.service.postProfileDetails(this.id,this.details).subscribe(res=>{
    if(this.creditpoint){
      this.postCredit();
    }else{
      this.getUser();
    }
    this.handler.res('Profile Details Updated Successfully');  
    if(this.url.includes('editcustomerProfile2')){
      this.router.navigate(["profile1"]);
    }else{
      this.router.navigate(['/customer']);
    }

  },err=>{
    this.handler.staticError(err)
    this.loader=false;
  }) 
  }
  postCredit(){
   this.service.postCreadits(this.id,this.creditpoint).subscribe(res=>{
     this.creditpoint='';
     this.getUser();
   },err=>{
     this.handler.staticError(err)
   })
  }
  handleFile(files) {
    var img = new Image();
    img.src = URL.createObjectURL(files[0]);
    img.onload = (data) => {
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      this.pic = canvas.toDataURL('image/jpeg', 0.07);
      const file = this.DataURIToBlob(this.pic)
      
      setTimeout(() => {    
        const formData = new FormData();
      formData.append('upload', file, 'image.jpg')  
      }, 2000);
      
      
    }
}

DataURIToBlob(dataURI: string) {
  const splitDataURI = dataURI.split(',')
  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i)

  return new Blob([ia], { type: mimeString })
}

onInput() {
  this.location.autoComplete();
  }

  ionViewWillLeave(){
    sessionStorage.removeItem('mobile#')
    this.location.cityId="";
    this.location.stateId="";
    this.location.regionId="";
    this.location.street="";
    this.location.stateId="";
    this.flatName="";
    this.flatNo="";
    this.location.houseNbr="";
    this.location.zipcode="";
    this.location.lat="";
    this.location.lon="";
    this.numb="";
    this.fName="";
    this.location.newSearch="";  
    sessionStorage.removeItem('mobile#')
     sessionStorage.removeItem('firstName')
  }
  cancel(){
    if(this.url.includes('newCustomer')){
      this.router.navigate(["vendor-subs"]);
    } 
    if(this.url.includes('newCustomerService')){
      this.router.navigate(["manage-ondemand-req"]);
    }
    if(this.url.includes('customerProfile')){
      this.router.navigate(["customer"]);
  }
  if(this.url.includes('editcustomerProfile')){
    this.router.navigate(["customer"]);
  }
  if(this.url.includes('editcustomerProfile2')){
    this.router.navigate(["profile1"]);
  }
   
  }


getAppt(id){
  this.appt = id;
}

openPasswordPolicy(){
  this.passwordPolicy=true;
}
closepwdpolicy(){
this.passwordPolicy=false;
}

 }
 